<template>
    <div id="actsFilter" class="pb-10">
        <v-expansion-panels flat>
            <v-expansion-panel>
                <v-expansion-panel-header class="pa-0" hide-actions>
                    <template v-slot:default="{ open }">
                        <div class="d-flex align-center">
                            <div class="text-subtitle-1 font-weight-bold gray--text">Фильтр</div>
                            <v-icon color="gray" v-if="open">arrow_drop_up</v-icon>
                            <v-icon color="gray" v-if="!open">arrow_drop_down</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="v-row">
                    <v-row>
                        <v-col>
                            <div class="gray--text">Выберите период создания актов на отключение / подключение</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <pre-trial-date-picker label="с дд.мм.гггг по дд.мм.гггг" isRange :date.sync="filter.date" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-checkbox color="gray" label="Должники" v-model="filter.is_debtor" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>Документ подписан:</div>
                            <v-radio-group row v-model="filter.signed">
                                <v-radio
                                    color="gray"
                                    v-for="signStatus in signingStatuses"
                                    :key="signStatus.label"
                                    :label="signStatus.label"
                                    :value="signStatus.value"
                                ></v-radio
                            ></v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-if="isContract">
                        <v-col>
                            <v-text-field
                                hide-spin-buttons
                                type="text"
                                color="gray"
                                append-icon="search"
                                outlined
                                v-model="filter.contractor_name"
                                label="Наименование контрагента"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                :disabled="!isRoleManagementReport"
                                outlined
                                :items="engineers"
                                label="Инженер ЭР"
                                item-text="person_ea_name_show"
                                item-value="isas_engineer_rid"
                                v-model="filter.engineer_rid"
                            />
                        </v-col>
                        <v-col>
                            <v-text-field
                                hide-spin-buttons
                                type="number"
                                color="gray"
                                append-icon="search"
                                outlined
                                v-model.number="filter.id"
                                :label="serialNumberLabel"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <AddressSelector v-model="filter.address" ref="addressSelector">
                                <v-text-field
                                    color="gray"
                                    append-icon="arrow_drop_down"
                                    placeholder="Выберите адрес"
                                    class="pointer"
                                    outlined
                                    readonly
                                    hide-details
                                    clearable
                                    v-model="filter.address.address_full_name"
                                ></v-text-field>
                            </AddressSelector>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>Текущее состояние услуги Горячая вода:</div>
                            <v-radio-group row v-model="filter.is_connected_gvs">
                                <v-radio
                                    color="gray"
                                    v-for="gvsStatus in gvsState"
                                    :key="gvsStatus.label"
                                    :label="gvsStatus.label"
                                    :value="gvsStatus.value"
                                ></v-radio
                            ></v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <div>Текущее состояние услуги Отопление:</div>
                            <v-radio-group row v-model="filter.is_connected_heat">
                                <v-radio
                                    color="gray"
                                    v-for="heatStatus in heatState"
                                    :key="heatStatus.label"
                                    :label="heatStatus.label"
                                    :value="heatStatus.value"
                                ></v-radio
                            ></v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn color="white" outlined @click="resetFilter" class="mr-10 gray--text">Сбросить</v-btn>
                            <v-btn color="gray" class="white--text" @click="applyFilter">Применить</v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>
<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import AddressSelector from '@/components/administration/AddressSelector.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ActsFilter',
    components: { AddressSelector, PreTrialDatePicker },
    props: {
        filterModel: {
            required: true
        },
        isContract: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        ...mapState('users', ['userInfo']),
        filter: {
            get() {
                return this.filterModel;
            },
            set(value) {
                this.$emit('update:filterModel', value);
            }
        },
        serialNumberLabel() {
            return this.isContract ? 'Номер договора' : 'Номер лицевого счета';
        },
        engineers() {
            return this.$store.state.refs.engineers;
        },
        isRoleManagementReport() {
            return this.userInfo['role_code'] ? this.userInfo['role_code'].includes('management_reports') : false;
        }
    },
    data: function() {
        return {
            signingStatuses: [
                { label: 'Отображать все', value: 2 },
                { label: 'Подписан', value: 1 },
                { label: 'Не подписан', value: 0 }
            ],
            gvsState: [
                { label: 'Отключено', value: false },
                { label: 'Подключено', value: true }
            ],
            heatState: [
                { label: 'Отключено', value: false },
                { label: 'Подключено', value: true }
            ]
        };
    },
    methods: {
        ...mapActions('refs', ['fetchEngineers']),
        applyFilter() {
            this.$emit('applyFilter');
        },
        resetFilter() {
            this.$emit('resetFilter');
        }
    },
    async mounted() {
        await this.fetchEngineers();
    }
};
</script>

<style>
#actsFilter .v-expansion-panel-content__wrap {
    padding: 0;
}
</style>
